import { render, staticRenderFns } from "./FmTable.vue?vue&type=template&id=42c1048b&scoped=true&"
import script from "./FmTable.vue?vue&type=script&lang=js&"
export * from "./FmTable.vue?vue&type=script&lang=js&"
import style0 from "./FmTable.vue?vue&type=style&index=0&id=42c1048b&prod&scoped=true&lang=less&"
import style1 from "./FmTable.vue?vue&type=style&index=1&id=42c1048b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c1048b",
  null
  
)

export default component.exports